<template>
  <app-content>
    <app-content-body>

      <div class="inner">
        <p class="buttons">
          <a
              class="btn btn_action btn_add"
              title="Přidat uživatele"
              @click.prevent="createItem"
          >Přidat uživatele</a>
        </p>
        <h1 v-translate>Uživatelé</h1>
      </div>

      <app-table
          :data="sortedUsers"
          :highlight-rows-on-hover="true"
          clickable
          deletable
          :order="params.order"
          @sort="sortItems"
          @rowClick="goToDetail"
          @deleteRow="deleteItem"
          :loading="listLoading"
      >
        <app-table-column first sortable attribute="lastName" :label="translations.lastName">
          <template slot-scope="row">
            <strong>
              {{ row.lastName }}
            </strong>
          </template>
        </app-table-column>
        <app-table-column sortable attribute="firstName" :label="translations.firstName" />
        <app-table-column sortable attribute="position" :label="translations.position" />
        <app-table-column sortable attribute="role" :label="translations.role" >
          <template slot-scope="row">
            {{ enumsMap.get(row.role) }}
          </template>
        </app-table-column>
        <app-table-column sortable attribute="lastLogin" :label="translations.lastLogin">
          <template slot-scope="row">
            <div v-html="formatDate(row.lastLogin)" />
          </template>
        </app-table-column>
        <app-table-column sortable attribute="created" :label="translations.created">
          <template slot-scope="row">
            <div v-html="formatDate(row._created)" />
          </template>
        </app-table-column>
      </app-table>
    </app-content-body>
  </app-content>
</template>

<script>
import { sortBy } from 'utils/helpers'
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'

const itemsListMixin = getItemsListMixin({
  apiMethodsSuffix: 'Users',
  enumsMap: true
})

export default {
  name: 'users',
  mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
  data() {
    return {
      params: {
        order: 'lastName'
      }
    }
  },
  computed: {
    translations() {
      return {
        lastName: this.$gettext('Příjmení'),
        firstName: this.$gettext('Jméno'),
        position: this.$gettext('Pozice'),
        role: this.$gettext('Role'),
        lastLogin: this.$gettext('Poslední login'),
        created: this.$gettext('Založeno'),
      }
    },
    sortedUsers() {
      return sortBy(this.params.order)(this.items)
    },
    currentTitle() {
      return [
        this.$gettext('Uživatelé')
      ]
    }
  },
  methods: {
    sortItems({ order }) {
      this.params.order = order
    }
  }
}
</script>
